import { useEffect, useRef, useState } from 'react'
import useModalStore from '../../../zustand/store/useModalStore';
import { FocusTrap } from 'focus-trap-react';
import UpdatePswd_modal from './UpdatePswd_modal';
import WithdrawalUser_modal from './WithdrawalUser_modal';

import '../../../css/modal.css'
import { Pwd16 } from '../../../images/icons/icons_theme';

const MyPage = ({ overYn, setOverYn }) => {

    // localStorage에서 원하는 계정 정보 map으로 가져오기
    const keys = ['id', 'name', 'emogdesc', 'superAdmin', 'userprjt', 'userstrm', 'admnUserMng', 'admnAuditLog', 'admnExceldownLog'];
    const localValues = Object.fromEntries(keys.map(key => [key, localStorage.getItem(key)]));
    // 권한 Y 여부 확인
    const authYn = ['userprjt', 'userstrm', 'admnUserMng', 'admnAuditLog', 'admnExceldownLog'].reduce((acc, key) => {
        acc[`${key}_Y`] = localValues[key] === 'Y';
        return acc;
    }, {});

    // my page btn state
    const mypageModal = useModalStore((state) => state.mypageModal);
    const setMypageModal = useModalStore((state) => state.setMypageModal);

    // 비밀번호 변경 state
    const [updatePassOpen, setUpdatePassOpen] = useState(overYn === 'Y' ? true : false);
    const passInit = {
        useridno: localValues.id,
        prevpswd: '',
        newpswd: '',
        renewpswd: ''
    }
    const [updatePassInfo, setUpdatePassInfo] = useState(passInit);

    // 회원탈퇴 state
    const [withdrawalUserOpen, setWithdrawalUserOpen] = useState(false);
    const [withdrawalUser, setWithdrawalUser] = useState({
        username: localValues.name,
        useridno: localValues.id,
        userupid: localValues.id,
        deletereason: '01',
        deletemsg: '',
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const passNewParams = {
            ...updatePassInfo,
            [name]: value
        };
        setUpdatePassInfo(passNewParams);
        const withdrawalNewParams = {
            ...withdrawalUser,
            [name]: value
        };
        setWithdrawalUser(withdrawalNewParams);
    };

    const myModalRef = useRef();

    useEffect(() => {
        if (mypageModal) {
            setTimeout(() => {
                myModalRef.current?.focus();
            }, 0);
        }
    }, [mypageModal]);
    
    const myFocus = updatePassOpen || withdrawalUserOpen ? -1 : 0;
    
    return (
        <FocusTrap focusTrapOptions={{initialFocus: '.modal_container', fallbackFocus: '.modal_container'}}>
            <div className='modal_container' ref={myModalRef} tabIndex={-1}>
                <div className={`mypage_contents ${localValues.superAdmin !== 'true' ? 'py-14' : 'py-10'}`}>
                    <h4 className='text-center'>마이 페이지</h4>
                    <hr />
                    <div className='mypage_wrapper'>
                        <h5>기본정보</h5>
                        <hr />
                        <div className='mypage_text'>
                            <span className='bold w-12'>성명</span>
                            <span className='co_line'>|</span>
                            <span>{localValues.name}</span>
                        </div>
                        <hr />
                        <div className='mypage_text'>
                            <span className='bold w-12'>아이디</span>
                            <span className='co_line'>|</span>
                            <span>{localValues.id}</span>
                        </div>
                        <hr />
                        <div className='mypage_text'>
                            <span className='bold w-12'>비밀번호</span>
                            <span className='co_line'>|</span>
                            <button onClick={() => setUpdatePassOpen(true)} tabIndex={myFocus}><h6 className='pw_btn bg_ho_primary' aria-label='비밀번호 변경'><Pwd16 className='co_white' />비밀번호 변경</h6></button>
                        </div>
                        <hr />
                    </div>

                    <div className='mypage_wrapper'>
                        <h5>국가응급진료정보망 추가 정보</h5>
                        <hr />
                        <div className='mypage_text'>
                            <span className='bold w-12'>소속기관</span>
                            <span className='co_line'>|</span>
                            <span>{localValues.emogdesc}</span>
                        </div>
                        <hr />
                        <div className='mypage_text'>
                            <span className='bold w-12'>접근권한</span>
                            <span className='co_line'>|</span>
                            <span>
                                <label className='cursor-default'>
                                    <input
                                        type='checkbox'
                                        value={localValues.userprjt}
                                        checked={authYn.userprjt_Y} disabled />
                                    표준등록체계(NEDIS)
                                </label>
                            </span>
                            <span>
                                <label className='cursor-default'>
                                    <input
                                        type='checkbox'
                                        value={localValues.userstrm}
                                        checked={authYn.userstrm_Y} disabled />
                                    외상등록체계
                                </label>
                            </span>
                        </div>
                        {localValues.superAdmin !== 'true' ? '' :
                            <>
                                <hr />
                                <div className='mypage_text'>
                                    <span className='bold w-12'>인가권한</span>
                                    <span className='co_line'>|</span>
                                    <span>
                                        <label className='cursor-default'>
                                            <input
                                                type='checkbox'
                                                value={localValues.admnUserMng}
                                                checked={authYn.admnUserMng_Y} disabled />
                                            사용자 관리
                                        </label>
                                    </span>
                                    <span>
                                        <label className='cursor-default'>
                                            <input
                                                type='checkbox'
                                                value={localValues.admnAuditLog}
                                                checked={authYn.admnAuditLog_Y} disabled />
                                            감사로그
                                        </label>
                                    </span>
                                    <span>
                                        <label className='cursor-default'>
                                            <input
                                                type='checkbox'
                                                value={localValues.admnExceldownLog}
                                                checked={authYn.admnExceldownLog_Y} disabled />
                                            엑셀 다운로드 로그
                                        </label>
                                    </span>
                                </div>
                            </>
                        }
                        <hr />
                    </div>
                    <hr />
                    <div className='my_btn_box'>
                        <button className='my_close_btn' onClick={() => setMypageModal(false)} tabIndex={myFocus}>닫기</button>
                        <button className='withdrawal_btn hover_co_red_color' onClick={() => setWithdrawalUserOpen(true)} tabIndex={myFocus}>탈퇴하기</button>
                    </div>

                    {/* 비밀번호 변경 modal */}
                    <UpdatePswd_modal
                        updatePassInfo={updatePassInfo}
                        setUpdatePassInfo={setUpdatePassInfo}
                        updatePassOpen={updatePassOpen}
                        setUpdatePassOpen={setUpdatePassOpen}
                        handleInputChange={handleInputChange}
                        passInit={passInit}
                        setOverYn={setOverYn}
                        overYn={overYn}
                    />

                    {/* 회원탈퇴 modal */}
                    <WithdrawalUser_modal
                        withdrawalUser={withdrawalUser}
                        setWithdrawalUser={setWithdrawalUser}
                        withdrawalUserOpen={withdrawalUserOpen}
                        setWithdrawalUserOpen={setWithdrawalUserOpen}
                        handleInputChange={handleInputChange}
                        setMypageModal={setMypageModal}
                    />
                </div>
            </div>
        </FocusTrap>
    )
}

export default MyPage